/**
 * KDSnackbar — Controlled snackbar component
 */

import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";

function KDSnackbar({ open, onClose, message, severity = "info", icon, title, dateTime, ...rest }) {
  return (
    <Snackbar
      open={open}
      autoHideDuration={5000}
      onClose={onClose}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      {...rest}
    >
      <Alert
        severity={severity}
        variant="filled"
        onClose={onClose}
        sx={{ width: "100%", borderRadius: (theme) => theme.borders.borderRadius.lg }}
        action={
          <IconButton size="small" onClick={onClose} sx={{ color: "inherit" }}>
            <Icon fontSize="small">close</Icon>
          </IconButton>
        }
      >
        {title && <strong>{title}</strong>}
        {title && <br />}
        {message}
      </Alert>
    </Snackbar>
  );
}

export default KDSnackbar;
